import type { FC } from "react";
import { Button, Stack } from "@mui/material";

/** Варианты уточнения (AskUser): кнопка отправляет вариант как ответ; свой ответ пишется в поле. */
export const OptionButtons: FC<{
  options: string[];
  disabled: boolean;
  onSelect: (option: string) => void;
}> = ({ options, disabled, onSelect }) =>
  options.length ? (
    <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mt: 1 }}>
      {options.map((o, i) => (
        <Button
          key={`${i}-${o}`}
          size="small"
          variant="outlined"
          color="inherit"
          disabled={disabled}
          onClick={() => onSelect(o)}
          sx={{
            borderRadius: 999,
            borderColor: "divider",
            textAlign: "left",
            "&:hover": {
              borderColor: "primary.main",
              color: "primary.main",
              bgcolor: "action.hover",
            },
          }}
        >
          {o}
        </Button>
      ))}
    </Stack>
  ) : null;
